import React, { useState, useEffect, useCallback } from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";

import toastr from "toastr";

import {
  employeeToUserFieldRules,
  initialEmpToUserField,
} from "app/_pages/UserManagement/Employee/Constant";
import { RoleService } from "app/_services/RoleService/RoleService";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { Validation } from "app/_helpers/validation/Validation";
import { employeeToUser } from "app/_services/UserManagement/EmployeeService";

import localStorageService from "app/services/localStorageService";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import {
  HO_Work_Flow_Role_List,
  MINE_Work_Flow_Role_List,
  RO_Work_Flow_Role_List,
  UserWorkFlowRoleList,
} from "app/_constants/constant";
import { isSuperAdmin } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";

const initialUserPermission = UserWorkFlowRoleList.reduce(
  (prev, next) => ({ ...prev, [next.name]: next.value ?? false }),
  {}
);
function UserSiteModal({ show, setShow, employee, user = null, getAllList, title }) {
  const [siteList, setSiteList] = useState([]);
  const [roleArr, setRoleArr] = useState([]);

  const [form, setForm] = useState({
    ...initialEmpToUserField,
  });

  const [userPermission, setUserPermission] = useState({
    ...initialUserPermission,
  });

  const [error, setError] = useState({});

  /***************** Api Call ********************/

  const getRolesList = useCallback(async () => {
    let response = await RoleService.RoleList("filter[status]=1");

    if (response?.status && Array.isArray(response?.data?.roles)) {
      const auth_user = localStorageService.getItem("auth_user");
      // console.log("response?.data?.roles", response.data.roles);
      setRoleArr(
        response.data.roles.filter((role) =>
          auth_user?.user?.role?.roleLable &&
          role.roleLable > auth_user?.user?.role?.roleLable
            ? true
            : false
        )
      );
    } else {
      setRoleArr([]);
    }
  }, []);

  const getAllSiteList = useCallback(async () => {
    let response = await getAllSites("filter[status]=1&filter[activeStatus]=active");
    if (!response?.data || !response?.status) return;

    setSiteList(response.data);
  }, []);

  /***************** Normal Function ********************/

  const onChange = ({ target: { name, value, type, checked } }) => {
    let extraToChange = {};

    if (name === "siteId") {
      extraToChange.siteType = siteList.find((d) => d.id === value)?.siteType;
      if (form.siteId !== value) setUserPermission({ ...initialUserPermission });
    }

    setForm((prevForm) => ({
      ...prevForm,
      ...extraToChange,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeUserPermission = ({ target: { name, value, type, checked } }) => {
    setUserPermission((prevForm) => ({
      ...prevForm,

      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleClose = (flag) => {
    setShow(false);
    setForm({ ...initialEmpToUserField });
    setUserPermission({ ...initialUserPermission });
    if (flag && getAllList) getAllList();
  };

  /***************** Submit ********************/

  const onSubmitAddUser = async () => {
    let flag = 0;

    let errorObj = Validation(form, employeeToUserFieldRules);
    if (Object.values(errorObj).filter((d) => d !== "").length) {
      flag = 1;
    }
    setError(errorObj);

    if (flag !== 0) return;

    let formObj = {
      roleId: form.roleId,
      siteId: form.siteId,
      userPermissions: userPermission,
    };

    if (employee) {
      let empObj = {
        firstName: employee?.firstName,
        lastName: employee?.lastName,
        email: employee?.email,
        dob: employee.dob,
        empId: employee.id,
      };

      formObj = { ...formObj, ...empObj };
    }

    if (user) formObj.userId = user.id;

    let response = await employeeToUser({ userData: formObj });

    if (!response?.status) return toastr.error(response?.message);

    toastr.success(response.message || "Success.");
    handleClose(true);
  };

  /***************** UseEffect ********************/

  useEffect(() => {
    getRolesList();
    getAllSiteList();
  }, [getAllSiteList, getRolesList]);

  useEffect(() => {
    if (user) {
      setForm((prev) => ({
        ...prev,
        roleId: user?.roleId,
        siteId: user?.employee?.currentWorkLocation || user?.siteId,
        siteType: user?.employee?.ehsSite?.siteType || user?.ehsSite?.siteType,
      }));

      setUserPermission((prev) => ({
        ...prev,
        ...(user?.accessPermissions || []).reduce(
          (prevPermission, next) => ({
            ...prevPermission,
            [next.permission]: +next.permissionValue ? true : false,
          }),
          {}
        ),
      }));
    }
  }, [user]);

  useEffect(() => {
    if (employee) {
      setForm((prev) => ({
        ...prev,

        siteId: employee.currentWorkLocation || "",
        siteType: employee?.ehsSite?.siteType,
      }));
    }
  }, [employee]);

  //console.log("/**/*/***//*/", roleArr);

  return (
    <Modal size="xl" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col md={6}>
            <label>Site</label>

            <SimpleSelect
              name="siteId"
              value={form.siteId}
              onChange={onChange}
              id="id"
              label="name"
              options={siteList}
              init="Select"
              menuPortalTarget={null}
              disabled={true}
            ></SimpleSelect>
            {error?.siteId && <span className="fromerror">{error?.siteId}</span>}
          </Col>

          <Col md={6}>
            <label>Role</label>
            <SimpleSelect
              name="roleId"
              value={form.roleId}
              onChange={onChange}
              options={
                !user?.role?.siteType && user
                  ? roleArr.filter((d) => !d.siteType)
                  : roleArr.filter((d) => d.siteType === +form.siteType)
              }
              id="id"
              label="title"
              menuPortalTarget={null}
              disabled={!user?.role?.siteType && user ? true : false}
            ></SimpleSelect>
            {error?.roleId && <span className="fromerror">{error?.roleId}</span>}
          </Col>
        </Row>

        <UserPermissionCheckbox
          form={userPermission}
          onChange={(e) => onChangeUserPermission(e)}
          siteType={form?.siteType || null}
        />
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <div>
          <Button variant="secondary" onClick={() => handleClose()}>
            Close
          </Button>
          <Button className="ml-2" onClick={onSubmitAddUser} variant="primary">
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default UserSiteModal;

const UserPermissionCheckbox = ({ form, onChange, title, siteType }) => {
  console.log("/*//*//form", form, onChange, title, siteType);
  let scopeRoles = (() => {
    const obj = {};

    let roles = [];

    switch (siteType) {
      case 1:
        roles = HO_Work_Flow_Role_List;
        break;
      case 2:
        roles = RO_Work_Flow_Role_List;
        break;
      case 3:
        roles = MINE_Work_Flow_Role_List;
        break;
      default:
        break;
    }
    roles.forEach((role) => {
      if (!obj[role.scope]) obj[role.scope] = [role];
      else obj[role.scope].push(role);
    });

    return Object.keys(obj).map((key) => ({
      title: key,
      roles: obj[key],
      col: obj[key].length === 1 ? 12 : 12,
    }));
  })();
  if (!isSuperAdmin()) {
    scopeRoles.filter((item) => item.title !== "Support");
    const filteredRoles = scopeRoles.filter((item) => item.title !== "Support");
    scopeRoles = filteredRoles;
  }

  return (
    <div className="mt-3">
      <label className="mb-2">{title}</label>

      <hr style={{ background: "#ccc" }} className="mt-0 mb-4" />

      <div className="row mx-0">
        {scopeRoles.map(({ title: scopeTitle, roles, col }) => (
          <div className={"mt-2 px-0 col-" + col}>
            <h5 className="mb-0">{scopeTitle}</h5>

            <Row>
              <Col md={col === 6 ? 6 : 12}>
                <hr className="mb-2 mt-0" />
              </Col>
              {roles.map((workRole) => (
                <Col md={col === 6 ? 12 : 4} key={workRole.name}>
                  <label className="checkbox checkbox-primary mb-4">
                    <input
                      type="checkbox"
                      name={workRole.name}
                      checked={form[workRole.name]}
                      onChange={onChange}
                      // disabled={!workRole[siteType]}
                    />
                    <span
                    // className={!workRole[siteType] ? "text-light" : ""}
                    >
                      {workRole.label}
                    </span>
                    <span className="checkmark"></span>
                  </label>
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </div>
    </div>
  );
};
